import React from 'react';

export default function getComponentFromChildren({ children, components }) {
  let match = null;
  React.Children.forEach(children, function(child) {
    if (child && components.some(component => component === child.type))
      match = child;
  });

  return match;
}
